import {
  HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_SET,
  HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_REQ,
  HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_SUCCESS,
  HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_ERROR,
  TOP_HOSTS_STATISTICS_LIST_SET,
  TOP_HOSTS_STATISTICS_LIST_REQ,
  TOP_HOSTS_STATISTICS_LIST_SUCCESS,
  TOP_HOSTS_STATISTICS_LIST_ERROR,
  TOP_PROGRAMS_STATISTICS_LIST_SET,
  TOP_PROGRAMS_STATISTICS_LIST_REQ,
  TOP_PROGRAMS_STATISTICS_LIST_SUCCESS,
  TOP_PROGRAMS_STATISTICS_LIST_ERROR
} from './statistics.type'
import moment from 'moment-timezone'
import ApiRest from '@/api/api-rest'
import Statistics from '@/resources/models/Statistics'
import HourlyStatistics from '@/resources/models/HourlyStatistics'
import IQCollection from '@/resources/collections/IQCollection'

import { loginFailuresAgentListMetaInfo } from '@/column-header/statistics/loginfailures-agents-meta'
import { loginFailuresSourceIpListMetaInfo } from '@/column-header/statistics/loginfailures-sourceip-meta'
import { OrderByEnum } from '@/constants/orderby.constants'

const timezoneString = `timezone=${moment.tz.guess()}`

const state = {
  hrlyConnectAcceptsStatisticsReqStatus: '',
  hrlyConnectAcceptsStatistics: {},
  topHostsStatisticsReqStatus: '',
  topHostsAcceptsStatistics: {},
  topHostsConnectsStatistics: {},
  topProgramsStatisticsReqStatus: '',
  topProgramsAcceptsStatistics: {},
  topProgramsConnectsStatistics: {}
}

const getters = {
  hrlyConnectAcceptsStatisticsReqStatus: state => state.hrlyConnectAcceptsStatisticsReqStatus,
  hrlyConnectAcceptsStatistics: state => state.hrlyConnectAcceptsStatistics,
  topHostsStatisticsReqStatus: state => state.topHostsStatisticsReqStatus,
  topHostsAcceptsStatistics: state => state.topHostsAcceptsStatistics,
  topHostsConnectsStatistics: state => state.topHostsConnectsStatistics,
  topProgramsStatisticsReqStatus: state => state.topProgramsStatisticsReqStatus,
  topProgramsAcceptsStatistics: state => state.topProgramsAcceptsStatistics,
  topProgramsConnectsStatistics: state => state.topProgramsConnectsStatistics
}

// Best Practice - updates state
const mutations = {
  [HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_SET]: (state, data) => {
    state.hrlyConnectAcceptsStatistics = data
  },
  [HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_REQ]: state => {
    state.hrlyConnectAcceptsStatisticsReqStatus = 'loading'
  },
  [HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_SUCCESS]: (state, data) => {
    state.hrlyConnectAcceptsStatisticsReqStatus = 'saved'
  },
  [HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_ERROR]: (state, errMsg) => {
    state.hrlyConnectAcceptsStatisticsReqStatus = 'error'
  },
  [TOP_HOSTS_STATISTICS_LIST_SET]: (state, data) => {
    state.topHostsAcceptsStatistics = data.accepts
    state.topHostsConnectsStatistics = data.connects
  },
  [TOP_HOSTS_STATISTICS_LIST_REQ]: state => {
    state.topHostsStatisticsReqStatus = 'loading'
  },
  [TOP_HOSTS_STATISTICS_LIST_SUCCESS]: (state, data) => {
    state.topHostsStatisticsReqStatus = 'saved'
  },
  [TOP_HOSTS_STATISTICS_LIST_ERROR]: (state, errMsg) => {
    state.topHostsStatisticsReqStatus = 'error'
  },
  [TOP_PROGRAMS_STATISTICS_LIST_SET]: (state, data) => {
    state.topProgramsAcceptsStatistics = data.accepts
    state.topProgramsConnectsStatistics = data.connects
  },
  [TOP_PROGRAMS_STATISTICS_LIST_REQ]: state => {
    state.topProgramsStatisticsReqStatus = 'loading'
  },
  [TOP_PROGRAMS_STATISTICS_LIST_SUCCESS]: (state, data) => {
    state.topProgramsStatisticsReqStatus = 'saved'
  },
  [TOP_PROGRAMS_STATISTICS_LIST_ERROR]: (state, errMsg) => {
    state.topProgramsStatisticsReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_REQ] (context, queryDate) {
    return new Promise((resolve, reject) => {
      context.commit(HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_REQ)
      ApiRest()
        .get(`/bi/stats/hourly/${queryDate}?${timezoneString}`)
        // .get('static/json/hrlyConnectAcceptsStatistics.json')
        .then(({ data }) => {
          let hrlyConnectAcceptsStats = new HourlyStatistics('', data[0].accepts, {
            date: queryDate,
            labelProperty: 'hour',
            labelValue: 'count',
            title: 'Accepts',
            chartOptions: {
              legend: {
                display: true
              },
              subtitle: 'Count'
            }
          })

          hrlyConnectAcceptsStats.groupChartData(data[0].connects, undefined, {
            title: 'Connects',
            backgroundColor: '#bce1ff',
            borderColor: '#179fff'
          })

          context.commit(HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_SET, hrlyConnectAcceptsStats)
          resolve(hrlyConnectAcceptsStats)
        })
        .catch(errMsg => {
          context.commit(HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_SUCCESS] (context) {
    context.commit(HRLY_CONNECTS_ACCEPTS_STATISTICS_LIST_SUCCESS)
  },
  [TOP_HOSTS_STATISTICS_LIST_REQ] (context, queryDate) {
    return new Promise((resolve, reject) => {
      context.commit(TOP_HOSTS_STATISTICS_LIST_REQ)
      ApiRest()
        .get(`/bi/stats/top-hosts/${queryDate}?${timezoneString}`)
        .then(({ data }) => {
          let agents = context.rootState.agents.agentList.models
          let topHostsAcceptsStats = new Statistics('', data[0].accepts, {
            date: queryDate,
            labelProperty: 'agentId',
            labelValue: 'count',
            chartOptions: {
              title: {
                display: true,
                text: 'Accepts'
              }
            }
          })
          topHostsAcceptsStats.setLabelHostnames(agents)

          let topHostsConnectsStats = new Statistics('', data[0].connects, {
            date: queryDate,
            labelProperty: 'agentId',
            labelValue: 'count',
            backgroundColor: '#bce1ff',
            borderColor: '#179fff',
            chartOptions: {
              title: {
                display: true,
                text: 'Connects'
              }
            }
          })
          topHostsConnectsStats.setLabelHostnames(agents)

          let topStats = {
            accepts: topHostsAcceptsStats,
            connects: topHostsConnectsStats
          }

          context.commit(TOP_HOSTS_STATISTICS_LIST_SET, topStats)
          resolve(topStats)
        })
        .catch(errMsg => {
          context.commit(TOP_HOSTS_STATISTICS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TOP_HOSTS_STATISTICS_LIST_SUCCESS] (context) {
    context.commit(TOP_HOSTS_STATISTICS_LIST_SUCCESS)
  },

  [TOP_PROGRAMS_STATISTICS_LIST_REQ] (context, queryDate) {
    return new Promise((resolve, reject) => {
      context.commit(TOP_PROGRAMS_STATISTICS_LIST_REQ)
      ApiRest()
        .get(`/bi/stats/top-programs/${queryDate}?${timezoneString}`)
        .then(({ data }) => {
          let topProgramsAcceptsStats = new Statistics('', data[0].accepts, {
            date: queryDate,
            labelProperty: 'programName',
            labelValue: 'count',
            chartOptions: {
              title: {
                display: true,
                text: 'Accepts'
              }
            }
          })

          let topProgramsConnectsStats = new Statistics('', data[0].connects, {
            date: queryDate,
            labelProperty: 'programName',
            labelValue: 'count',
            backgroundColor: '#bce1ff',
            borderColor: '#179fff',
            chartOptions: {
              title: {
                display: true,
                text: 'Connects'
              }
            }
          })

          let topStats = {
            accepts: topProgramsAcceptsStats,
            connects: topProgramsConnectsStats
          }

          context.commit(TOP_PROGRAMS_STATISTICS_LIST_SET, topStats)
          resolve(topStats)
        })
        .catch(errMsg => {
          context.commit(TOP_PROGRAMS_STATISTICS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TOP_PROGRAMS_STATISTICS_LIST_SUCCESS] (context) {
    context.commit(TOP_PROGRAMS_STATISTICS_LIST_SUCCESS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/statistics/statistics.module.js